module.exports = __webpack_public_path__ + "static/img/v.4cf5ee32.png";